import { Phone, MapPin, Clock, MessageCircle } from "lucide-react";
import { PageHero } from "../components/sections";
import { Reveal, Eyebrow } from "../components/common";
import ContactForm from "../components/ContactForm";
import { IMAGES, COMPANY, ZONES } from "../data/site";
import Seo from "../components/Seo";
import { SEO } from "../data/seo";

export default function Contact() {
  return (
    <div data-testid="contact-page">
      <Seo {...SEO.contact} />
      <PageHero
        eyebrow="Contact"
        title="Demandez votre <em style='color:var(--gold-2)'>devis gratuit</em>"
        sub="Pour la gestion et l'entretien de vos locations Airbnb à Béziers et sur le littoral. Devis rapide et accompagnement personnalisé."
        image={IMAGES.coastNight}
      />

      <section className="section">
        <div className="container-x grid lg:grid-cols-5 gap-12">
          <div className="lg:col-span-3">
            <Reveal><Eyebrow>Formulaire</Eyebrow></Reveal>
            <Reveal delay={80}>
              <h2 className="display-title mt-3 text-4xl">Parlez-nous de votre projet</h2>
            </Reveal>
            <div className="mt-8">
              <ContactForm />
            </div>
          </div>

          <aside className="lg:col-span-2 space-y-5">
            <Reveal>
              <div className="p-8" style={{ background: "var(--ink)", color: "#fff" }}>
                <Eyebrow light>Coordonnées</Eyebrow>
                <ul className="mt-6 space-y-5">
                  <InfoRow icon={<Phone size={18} />} label="Téléphone">
                    <a href={`tel:${COMPANY.phoneIntl}`}>{COMPANY.phone}</a>
                  </InfoRow>
                  <InfoRow icon={<MessageCircle size={18} />} label="WhatsApp">
                    <a href={COMPANY.whatsapp} target="_blank" rel="noreferrer">Discuter maintenant</a>
                  </InfoRow>
                  <InfoRow icon={<MapPin size={18} />} label="Zone">
                    Béziers & littoral héraultais
                  </InfoRow>
                  <InfoRow icon={<Clock size={18} />} label="Disponibilité">
                    7j/7 · Réponse sous 24h
                  </InfoRow>
                </ul>
              </div>
            </Reveal>
            <Reveal delay={80}>
              <a
                href={COMPANY.whatsapp}
                target="_blank"
                rel="noreferrer"
                className="btn w-full justify-center"
                style={{ background: "#25d366", color: "#fff", boxShadow: "0 10px 30px -10px rgba(37,211,102,0.6)" }}
                data-testid="contact-whatsapp"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="#fff">
                  <path d="M12.04 2c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.46 3.45 1.32 4.95L2 22l5.25-1.38c1.45.79 3.08 1.21 4.79 1.21 5.46 0 9.91-4.45 9.91-9.91S17.5 2 12.04 2zm5.8 14.01c-.24.68-1.4 1.3-1.93 1.38-.49.07-1.13.1-1.82-.11-.42-.13-.96-.31-1.65-.61-2.9-1.25-4.8-4.17-4.94-4.36-.15-.19-1.18-1.57-1.18-3 0-1.43.75-2.13 1.02-2.42.27-.29.58-.36.78-.36.19 0 .39 0 .56.01.18.01.42-.07.66.5.24.58.83 2.01.9 2.16.07.14.12.31.02.5-.09.19-.14.31-.27.48-.14.17-.29.37-.41.5-.14.14-.28.29-.12.57.15.29.69 1.13 1.48 1.83 1.01.9 1.86 1.18 2.15 1.32.29.14.46.12.63-.07.17-.19.73-.85.92-1.14.19-.29.39-.24.66-.14.27.1 1.69.8 1.98.94.29.14.48.22.55.34.07.12.07.69-.17 1.37z" />
                </svg>
                Nous écrire sur WhatsApp
              </a>
            </Reveal>
            <Reveal delay={120}>
              <div className="p-8" style={{ background: "var(--cream)", border: "1px solid var(--line)" }}>
                <h3 className="font-display text-2xl">Notre zone d'intervention</h3>
                <p className="text-sm mt-2" style={{ color: "var(--muted)" }}>
                  De Béziers au Cap d'Agde, sur tout le littoral.
                </p>
                <div className="flex flex-wrap gap-2 mt-4">
                  {ZONES.map((z) => (
                    <span key={z.name} className="px-3 py-1.5 text-xs" style={{ background: "#fff", border: "1px solid var(--line)" }}>
                      {z.name}
                    </span>
                  ))}
                </div>
              </div>
            </Reveal>
          </aside>
        </div>
      </section>
    </div>
  );
}

function InfoRow({ icon, label, children }) {
  return (
    <li className="flex items-start gap-4">
      <div className="flex items-center justify-center" style={{ width: 42, height: 42, background: "rgba(189,155,84,0.15)", color: "var(--gold-2)", flexShrink: 0 }}>
        {icon}
      </div>
      <div>
        <div className="text-xs uppercase tracking-wider" style={{ color: "rgba(255,255,255,0.5)" }}>{label}</div>
        <div className="mt-1">{children}</div>
      </div>
    </li>
  );
}
